var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cover-branding"},[_c('img',{staticClass:"cover-branding-img",attrs:{"alt":_vm.brand.title,"src":_vm.brand.graphic}})])}
var staticRenderFns = []

export { render, staticRenderFns }